"use client";

import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setParallaxOffset(scrolled * 0.5);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="hero" ref={ref} className="dark text-foreground relative h-screen w-full overflow-hidden flex items-center justify-center !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] !bg-[hsl(0,0%,0%)] !bg-[url(https://rrrecoverysolutions.com/wp-content/uploads/2026/03/suburban_atlanta_home.webp)] !opacity-[0.7] !bg-[url(https://rrrecoverysolutions.com/wp-content/uploads/2026/03/suburban_atlanta_home.webp)] !bg-[url(https://rrrecoverysolutions.com/wp-content/uploads/2026/03/suburban_atlanta_home.webp)]">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548353/img/hero_warm_architectural_space.png)",
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 0.1s ease-out"
    }} />
      
      <div className="absolute inset-0 from-black/40 via-black/20 to-black/60 !bg-[hsl(0,0%,0%)] !opacity-[0.7]" />

      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
      transform: `translateY(-${parallaxOffset * 0.3}px)`
    }}>
        <h1 className="font-bold mb-6 leading-tight tracking-tight !text-6xl !text-[hsl(0,0%,100%)]">Find Out If You Have Unclaimed Money Owed to You in Georgia</h1>
        
        <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto">
          Many homeowners in Metro Atlanta are unaware they may still be entitled to money after foreclosure or property sales.
          <div>Roberts &amp; Roberts Recovery Solutions helps you recover what’s rightfully yours.</div>
        </p>

        

        <Button size="lg" onClick={() => {
        document.getElementById("fundsearch")?.scrollIntoView({
          behavior: "smooth"
        });
      }} className="bg-primary hover:bg-primary-hover text-foreground-primary font-semibold px-10 py-6 text-lg rounded-md shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">Start Your Recovery</Button>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="size-10 text-white/80" />
      </div>
    </section>;
}